import { Component, Renderer2, ChangeDetectorRef } from '@angular/core';
import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from '../models/BaseBus';
import { GlobalsService } from '../services/globals.service';
import { MessageType } from '../enums/MessageType';
import { BaseGridEditLineComponent } from './base-grid-editline.component';
import { CDocument } from '../models/CDocument';
import { AttachmentBus } from '../models/AttachmentBus';
import { BaseService } from '../services/base.service';
import { FileInfo, SelectEvent } from '@progress/kendo-angular-upload';
import { saveAs } from '@progress/kendo-file-saver';
import { DomSanitizer } from '@angular/platform-browser';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { ICPLoader } from '../decorators/cploader/cploader-decorator';
import { EmptyOverridable, validateOverridables } from '../decorators/overridable/base-method-override-decorator';

@Component({
    selector: '',
    template: '',
    standalone: false
})
export abstract class BaseGridEditAttachmentsComponent<T extends BaseBus,D, S extends BaseService> extends BaseGridEditLineComponent<T,D,S>  {

    constructor(protected globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, public sanitizer: DomSanitizer, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        validateOverridables(this, Object.getPrototypeOf(this).constructor.name, BaseGridEditAttachmentsComponent);
    }

    @EmptyOverridable()
    cellCloseHandler(e: any) { }

    documentData: any = "";
    documentDataURL: any;
    document: CDocument;
    draggingOver: boolean = false;
    zoneId = "ZN" + CommonFunctions.getGuid();
    hide() {
        this.viewingDocument = false;
    }
    clearUpload() {
        this.files = [];
    }
    view(data: AttachmentBus) {
        if (!data.id) {
            this.globals.notifyError("No document id found. Unable to view document", true);
            return;
        }
        this.dataLoading = true;
        this.viewingDocument = true;
        this.svc_data.getDocument(data.id).subscribe(
            {
                next:
                    data => {
                        this.dataLoading = false;
                        this.document = new CDocument(data);
                        if (this.document.hasDocumentB64String) {
                            this.document.setProperties();
                            this.documentData = this.sanitizer.bypassSecurityTrustResourceUrl("data:" + this.document.mimeType + ";base64," + data.documentB64String);
                            var binary = atob(data.documentB64String.replace(/\s/g, ''));
                            var len = binary.length;
                            var buffer = new ArrayBuffer(len);
                            var view = new Uint8Array(buffer);
                            for (var i = 0; i < len; i++) {
                                view[i] = binary.charCodeAt(i);
                            }

                            this.documentDataURL = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(new Blob([view], { type: "application/pdf" })));
                        }
                        else {
                            this.viewingDocument = false;
                            this.sendParentMessage(MessageType.msgPopup, "Missing Data", "No Attachment Data Found");
                        }
                    },
                error: err => {
                    console.error(err);
                    this.dataLoading = false;
                    this.viewingDocument = false;
                    this.globals.notifyError("Error retrieving document for viewing", true);
                }
        });
    }
    download(data: AttachmentBus) {
        if (!data.id) {
            this.globals.notifyError("No document id found. Canceling download", true);
            return;
        }
        this.svc_data.getDocument(data.id).subscribe(
            {
                next:
                    data => {
                        this.document = new CDocument(data);
                        let downloadData = "data:" + this.document.mimeType + ";base64," + data.documentB64String;
                        saveAs(downloadData, this.document.fullFileName);
                    },
                error: err => {
                    console.error(err);
                    this.globals.notifyError("Error downloading document", true);
                }
        });
    }
    files: Array<FileInfo> = [];
    uploadRemoveUrl: string;
    uploadRestrictions: any;

    selectEventHandler(e: SelectEvent) {
        this.files = e.files;
        this.genericCloseCtrl(e);
        this.setDirty();
    }

    completeEventHandler(e: any) {
        this.setDirty();
    }
    selectEventHandlerOutSide(e: SelectEvent, compCpLoader: ICPLoader) {
        if (this.canAddEdit) {
            compCpLoader?.cpLoaderOn(true);
            this.addHandler();
            this.selectEventHandler(e);
            compCpLoader?.cpLoaderOff();
        }
    }

    public cellClickHandler({ isEdited, dataItem, rowIndex, column, columnIndex }, editClicked: boolean = false): void {
        if (this.ctrlOpenFlag) {
            return;
        }
        super.cellClickHandler({ isEdited, dataItem, rowIndex, column, columnIndex }, editClicked);
    }

    onDragOver(evt) {
        this.draggingOver = true;
        evt.preventDefault();
        evt.stopPropagation();
    }

    onDragLeave(evt) {
        this.draggingOver = false;
        evt.preventDefault();
        evt.stopPropagation();
    }
}

